import { render, staticRenderFns } from "./PlayingBanner.vue?vue&type=template&id=464897b7&"
import script from "./PlayingBanner.vue?vue&type=script&lang=js&"
export * from "./PlayingBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlayingBanner.vue?vue&type=style&index=0&id=464897b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports